import { RSAA } from "redux-api-middleware";
import appHistory from "../appHistory";

export const GAMES_MENU_LOAD = "GAMES_MENU_LOAD";
export const GAMES_MENU_SET = "GAMES_MENU_SET";

const fetchEndpoints = {
  my: {
    live: `/api/v1/my/games/live`,
    finished: `/api/v1/my/games/finished`,
  },
  all: {
    live: `/api/v1/games/live`,
    finished: `/api/v1/games/finished`,
  },
  admin: {
    "pre-live": `/api/v1/backend/games/pre-live`,
    "in-registration": "/api/v1/backend/games/in-registration",
  },
};

const changeMenuAction = (status, scope) => ({
  type: GAMES_MENU_SET,
  payload: {
    status,
    scope,
  },
});

export function getMenuSelector(getState, status, scope) {
  return getState().gamesMenu.list.find(
    (e) => e.key.status === status && e.key.scope === scope
  );
}
export const changeMenu = ({ status, scope = "all" }) => (
  dispatch,
  getState
) => {
  const menu = getMenuSelector(getState, status, scope);
  if (menu) {
    return dispatch(changeMenuAction(status, scope));
  }

  return dispatch(fetchGamesMenuAction({ status, scope }));
};

export const changeMenuAndSelectFirstGame = ({ status, scope = "all" }) => (
  dispatch,
  getState
) => {
  const menu = getMenuSelector(getState, status, scope);

  const successCallback = () => {
    const menu = getMenuSelector(getState, status, scope);

    let game = menu.value.games[0];
    if (game) {
      appHistory.push(`/results/${game.id}`);
    }
  };

  if (menu) {
    dispatch(changeMenuAction(status, scope));
    successCallback();
  }

  dispatch(fetchGamesMenuAction({ status, scope }, successCallback));
};

const fetchGamesMenuAction = (
  { status, scope = "all" },
  successCallback = () => null
) => (dispatch) =>
  dispatch({
    [RSAA]: {
      endpoint: fetchEndpoints[scope][status],
      method: "GET",
      credentials: "same-origin",
      types: [
        "REQUEST",
        {
          type: "SUCCESS",
          payload: (action, state, res) =>
            res.json().then((json) => {
              dispatch({
                type: GAMES_MENU_LOAD,
                payload: {
                  key: { status, scope },
                  value: {
                    games: json.data,
                    sports: json.included
                      .filter((e) => e.type === "sport")
                      .sort((a, b) => {
                        if (a.name < b.name) return -1;
                        if (a.name > b.name) return 1;
                        return 0;
                      }),
                  },
                },
              });
              dispatch(changeMenuAction(status, scope));
              successCallback();
            }),
        },
        "FAILURE",
      ],
    },
  });
